var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363 21L363 49",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.5,
    cy: 16.3333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.987 16.1898C358.987 12.2835 362.288 9.11678 366.358 9.11678C366.943 9.11678 367.511 9.1841 368.056 9.30756C366.742 8.48044 365.187 8 363.519 8C358.814 8 355 11.8056 355 16.5C355 21.1944 358.814 25 363.519 25C365.814 25 367.895 24.0929 369.427 22.6205C368.492 23.0317 367.454 23.2628 366.358 23.2628C362.288 23.2628 358.987 20.0961 358.987 16.1898Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M372.402 15.6003L372.37 13.1461L370.535 14.7189L368.304 14.0564L369.112 16.3367L367.765 18.3813L370.1 18.2179L371.499 20.144L372.133 17.7627L374.345 16.9085L372.402 15.6003Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.5a54e8743337671ea69ca46ca20b0a8a.svg";
export { ForwardRef as ReactComponent };